export default {
    computed: {
        recaptchaPublicKey() {
            return process.env.VUE_APP_GOOGLE_RECAPTCHA_PUBLIC;
        }
    },
    methods: {
        initRecaptcha (onSubmit) {
            return new Promise((resolve) => {
                if (!document.querySelector('#recaptcha-script')) {
                    window.onRecaptchaSubmit = onSubmit;

                    const script = document.createElement('script');
                    script.id = 'recaptcha-script';
                    script.src = 'https://www.google.com/recaptcha/api.js';
                    script.async = true;
                    script.defer = true;
                    script.onload = () => {
                        resolve(true);
                    }

                    document.body.appendChild(script);
                } else {
                    window.onRecaptchaSubmit = onSubmit;
                    window.grecaptcha.render('recaptcha');
                    resolve(true);
                }
            });
        },
        resetRecaptcha() {
            window.grecaptcha.reset();
        },
        submitRecaptcha() {
            window.grecaptcha.execute();
        }
    }
}